import React, { useState, useEffect, Component } from "react";
import firebase from "firebase";
import StyleFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import Popout from 'react-popout'
import './Player.css'
import './Timer.css'

import SpotifyWebApi from 'spotify-web-api-js';

const SpotifyLink= (
  <a id="spotify-link" href="https://accounts.spotify.com/authorize?client_id=406cc2997faf481a8728801c5d7accd9&response_type=token&redirect_uri=https://spomodoro-92855.web.app/callback&scope=user-top-read%20user-read-private%20user-read-email%20user-read-playback-state&show_dialog=true
  "><button>Link Spotify Account</button></a>
)

/*
const SpotifyLink = (props) => {
  return (
    <div>
      <a href="https://accounts.spotify.com/authorize?client_id=406cc2997faf481a8728801c5d7accd9&response_type=token&redirect_uri=https://spomodoro-92855.web.app/callback&scope=user-top-read&show_dialog=true"><button onClick={this.clickHandler}>Link Spotify Account</button></a>
    </div>
  )
}*/

class FinalSignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spotifyLinked: false
    }
    this.clickHandler = this.clickHandler.bind(this)
  }
  clickHandler() {
    this.setState({
      isLinked: true
    })
  }
  render() {
    return (
      <div>
        <Signup spotifyLinked={this.isLinked} />
        <a href="https://accounts.spotify.com/authorize?client_id=406cc2997faf481a8728801c5d7accd9&response_type=token&redirect_uri=https://spomodoro-92855.web.app/callback&scope=user-top-read&show_dialog=true"><button onClick={this.clickHandler}>Link Spotify Account</button></a>
      </div>
    );
  }
}

/*class HostingComponent extends React.Component {
  constructor(props) {
    super(props);
    this.popout = this.popout.bind(this);
    this.popoutClosed = this.popoutClosed.bind(this);
    this.state = { isPoppedOut: false };
  }
 
  popout() {
    this.setState({isPoppedOut: true});
  }
 
  popoutClosed() {
    this.setState({isPoppedOut: false});
  }
 
  render() {
    if (this.state.isPoppedOut) {
      return (
        <Popout = window.open("", "", "")/>
        <Popout url='https://accounts.spotify.com/authorize?client_id=406cc2997faf481a8728801c5d7accd9&response_type=token&redirect_uri=https://spomodoro-92855.web.app/callback&scope=user-top-read&show_dialog=true'
        title='Spomodoro Spotify Link' 
        onClosing={this.popoutClosed}>
          <div>Popped out content!</div>
        </Popout>
      );
    } else {
      //var popout = <span onClick={this.popout} className="buttonGlyphicon glyphicon glyphicon-export"></span>
      return (
        <div>
            <button onClick={this.popout}> Link Spotify Account </button>
        </div>
      );
    }
  }
}*/

var uiConfig = {
  signInFlow: "popup",
  signInOptions: [
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
  callbacks: {
    signInSuccessWithAuthResult: async (authResult) => {
      const userInfo = authResult.additionalUserInfo;
      if (userInfo.isNewUser && userInfo.providerId === "password") {
        try {
          await authResult.user.sendEmailVerification();
          console.log("Check your email.");
        } catch (e) {
          console.log(e);
        }
      }
      return false;
    },
  },
};

const signOut = () => {
  firebase
    .auth()
    .signOut()
    .then(function () {
      console.log("Successufully Signed out");
    })
    .catch(function () {
      console.log("Error Signed out");
    });
};

const Signup = (props) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const user = firebase.auth().currentUser;
    const authObserver = firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
    });
    return authObserver;
  });

  console.log("user", user);

  if (user) {
    return (
      <>
        <p id="Load-msg">
          Welcome, {user.displayName} <br />
          <small>{user.email}</small> <br />
          <button id = "signout-btn" onClick={signOut}>Sign out</button> <br />
          {SpotifyLink}
          <Player />
          <Timer />
          {/* token = window.location.hash.substr(1).split('&')[0].split("=")[1] */}
          {/* <HostingComponent window = window.open("","","")/> */}
        </p>
      </>
    );
  } else {
    return (
      <>
        <div id = "sign-msg">Sign Up / Register to start using Spomodoro!
        <StyleFirebaseAuth id = "sign-btns" uiConfig={uiConfig} firebaseAuth={firebase.auth()} /></div>
        <div id = "App-intro">
      <p>Stay focused with playlists of music selected for qualities conducive to productive studying.</p>
      
      <p>Generate playlists to be as long as you want your work session to be.</p>
      
      <p>Save your favorite playlists and discover new artists.</p>
      </div>
      </>
    );
  }
};

const spotifyApi = new SpotifyWebApi();

class Player extends Component {
  constructor(){
    super();
    const params = this.getHashParams();
    const token = params.access_token;
    if (token) {
      spotifyApi.setAccessToken(token);
    }
    this.state = {
      loggedIn: token ? true : false,
      nowPlaying: { name: 'Not Checked', albumArt: '' }
    }
  }
  getHashParams() {
    var hashParams = {};
    var e, r = /([^&;=]+)=?([^&;]*)/g,
        q = window.location.hash.substring(1);
    e = r.exec(q)
    while (e) {
       hashParams[e[1]] = decodeURIComponent(e[2]);
       e = r.exec(q);
    }
    return hashParams;
  }

  getNowPlaying(){
    spotifyApi.getMyCurrentPlaybackState()
      .then((response) => {
        this.setState({
          nowPlaying: { 
              name: response.item.name, 
              albumArt: response.item.album.images[0].url
            }
        });
      })
  }
  render() {
    return (
      <div className="Player">
        <div>
          Now Playing: { this.state.nowPlaying.name }
        </div>
        <div>
          <img src={this.state.nowPlaying.albumArt} style={{ height: 150 }}/>
        </div>
        { this.state.loggedIn &&
          <button onClick={() => this.getNowPlaying()}>
            Check Now Playing
          </button>
        }
      </div>
    );
  }
}

//export default Player;
class Timer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      breakTime: 250,
      workTime: 1500,
      seconds: 1500,
      timerId: false,
      active: 'workTime',
      numSets: 0
    }

    this.playStop = this.playStop.bind(this);
    this.updateTime = this.updateTime.bind(this);
  }

  /* 
    update interval
  */

  // 
  updateTime() {
    this.setState(function(prevState, props) {
      const currentState = Object.assign(prevState);
      const stillActive = (prevState.seconds - 1) > 0;
      const nextTimer = prevState.active === 'workTime' ? 'breakTime' : 'workTime'

      currentState.seconds = stillActive ? currentState.seconds - 1 : currentState[nextTimer];
      
      const prevActive = currentState.active === 'workTime' ? true : false
      currentState.active = stillActive ? currentState.active : nextTimer;

      const newActive = currentState.active === 'workTime' ? true : false

      if (prevActive == true && newActive == false) {
        currentState.numSets = prevState.numSets + 1;
      }
      
      if (this.timerID) {
        currentState.timerId = this.timerID;
      }
      return currentState;
    });
  }

  // 
  playStop() {
      if (this.state.timerId) {
        clearInterval(this.state.timerId);
        return this.setState({
          seconds: this.state.workTime,
          timerId: false,
          active: 'workTime'
        });
      }

      this.timerID = setInterval(() => this.updateTime(), 1000)
    }
    // 
  updateLength(timer, e) {
    if (this.state.timerId) {
      return false;
    }
    
    const state = Object.assign({}, this.state);
    state[timer] = e.target.value * 60;
    state.seconds = timer === 'workTime' ? e.target.value * 60 : state.seconds
    this.setState(state);
  }
  render() {
    const buttonString = this.state.timerId ? 'Stop' : 'Start';
    return (
      <div className="pomo">
        <Time active={this.state.active} seconds={this.state.seconds} />
        <Button action={this.playStop}>{buttonString}</Button>
        <Option value={this.state.workTime} timer="workTime" updateLength={this.updateLength.bind(this)}>Minutes of work</Option>
        <Option value={this.state.breakTime} timer="breakTime" updateLength={this.updateLength.bind(this)}>Minutes of break</Option>
        <h4>Number of sets: {this.state.numSets}</h4>
      </div>
    )
  }
}

class Option extends React.Component {
  onChange (e) {
    e.preventDefault();
    this.props.updateLength(this.props.timer, e)
  }
  
  convertToMinutes (seconds) {
    return Math.floor(seconds / 60);
  }
  
  render() {
    return (
      <label className="input-group">
      {this.props.children}
      <input className="input-group__input" type="number" min="1" step="1" placeholder="Insert minutes" onChange={this.onChange.bind(this)} value={this.convertToMinutes(this.props.value)} />
      </label>
    )
  }
}

const Button = (props) => <button className="btn" onClick={props.action}>{props.children}</button>

class Time extends React.Component {
  twoDigits(num) {
    return num > 9 ? "" + num : "0" + num;
  }

  convertToHhMmSs(seconds) {
    const h = this.twoDigits(Math.floor(seconds / 3600));
    const m = this.twoDigits(Math.floor((seconds % 3600) / 60));
    const s = this.twoDigits(Math.floor(seconds % 3600 % 60));
    return `${h}:${m}:${s}`;
  };

  render() {
    var remainingTime = this.convertToHhMmSs(this.props.seconds);
    var activeTimer = this.props.active === 'workTime' ? 'It\'s time to work!' : 'Take a little break';

    return (
      <div className="timer">
        <p className="timer__description">{activeTimer}</p>
        <p className="timer__time">{remainingTime}</p>
      </div>
    )
  }
}


export default Signup;
//export default SpotifyLink;